// extracted by mini-css-extract-plugin
module.exports = {"inputWrap":"FormText_inputWrap__f6ZAi","input":"FormText_input__hY6Ac","root--error":"FormText_root--error__v1cn6","rotation":"FormText_rotation__MBYd_"};